<template>
  <div>

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import mixin from "../../orderManage/nonContractOrder/own/mixin";

export default {
  mixins: [tableMixin, mixin],
  data() {
    return {
      baseUrl: 'order',
      formInline: {
        isstatus: 1,
        order_type: 3, // 全部订单
      },
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 150 },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "name", label: "货物名称", minwidth: 110 },
        { keyName: "pricing", label: "计价方式", minwidth: 110 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { ...this.ctrls.ZhuangHuoRiQi, },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/cOrder/view?id=${id}&mode=view`
            );
          },
        },
      ],
      baseParams: ['isstatus', 'order_type'],
      team: [],
    };
  },
  methods: {
  },
  created() {},
  mounted() {
    // const { user_group_id } = this.user
    // if (user_group_id == 5) {
    //   // 由于本身没有baseParams，有了baseParams手动触发首次请求
    //   this.getList();
    // }
  },
};
</script>

<style lang="less" scoped>
/deep/.detail {
  font-size: 14px;
  font-weight: 400;
  color: #2691FF;
  cursor: pointer;
}

.main .tab {
  /deep/ .el-tabs__header {
    padding: 0;

    .el-tabs__nav {
      .el-tabs__active-bar {
        height: 0;
      }

      .el-tabs__item {
        width: auto;
        height: 40px;
        line-height: 40px;
        margin: 0 10px;
        padding: 0 20px;
        transition: border-color .3s, background-color .3s, color .3s;

        &.is-active {
          border-bottom: 3px solid #2691FF;
          box-sizing: border-box;
          transition: border-color .3s, background-color .3s, color .3s;
        }
      }
    }
  }
}
</style>